import { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import api from "../services/axiosInstance";
import { backendPort } from '../components/Fungsiku';
import { useNotification } from './NotifPopup';
import {sortData} from '../components/Fungsiku';
import {ShowPic} from '../components/ShowPic';
import {ExcelDown} from '../components/ExcelDown';

const REQ_GROUP_PAGE18_OPSI_LOAD = 'page18-opsi-load';
const REQ_GROUP_PAGE18_JURNAL_LOAD = 'page18-jurnal-load';

//LPJ PETTY CASH
export function PageKonten18({token, authIdentity = {}, globalOpsi}) {
  const opsiCabang = globalOpsi.opsiCabang;
  const kodeCabangUser = String(authIdentity?.kode_cabang || "").trim();
  const namaUser = String(authIdentity?.nama || "").trim();
  const isPusat = kodeCabangUser === "C-1";
  const namaCabangUser = (
    isPusat
      ? "Pusat"
      : (
        (Array.isArray(opsiCabang) ? opsiCabang : []).find(
          (x) => String(x?.kode_cabang || "").trim() === kodeCabangUser
        )?.nama_cabang || kodeCabangUser || "-"
      )
  );
  const [loading, setLoading] = useState(false);
  const [cabang, setCabang] = useState(isPusat ? '' : kodeCabangUser);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const formatWIB = (isoUTC) => { //output dari mysql string ISO jadi dirubah ke DD/MM/YYYY untuk ditampilkan di tabel
    if (!isoUTC) return "";
    const date = new Date(isoUTC);
    return date.toLocaleDateString("id-ID", {
        timeZone: "Asia/Jakarta"
    });
  };  
  const trimTxt = (txt) =>    (txt ?? "")
                              .toString()
                              .toLowerCase()
                              .replace(/[\r\n]+/g, "")
                              .trim();
  //const formatBulan = (value) => {return new Intl.DateTimeFormat("id-ID", {month: "long"}).format(new Date(tahun, value-1, 1))}; //ubah angka menjadi nama bulan  
  const awalBulan = () =>  {
    const now = new Date();
    const year = now.toLocaleString("en-CA", {
        timeZone: "Asia/Jakarta",
        year: "numeric"
    });
    const month = now.toLocaleString("en-CA", {
        timeZone: "Asia/Jakarta",
        month: "2-digit"
    });

  return `${year}-${month}-01 00:00:00`;
};
  const today = () => {return new Date().toLocaleDateString("en-CA", {timeZone: "Asia/Jakarta"});}; //YYYY-MM-DD
  const validateRange = (start, end) => {
        if (!start || !end) return false;
        const startDate = new Date(start);
        const endDate = new Date(end);
        if (endDate < startDate) {
            showNotif("error","Tanggal akhir tidak boleh lebih kecil dari tanggal mulai");
            return false;
        }

        const diffDays =
            (endDate - startDate) / (1000 * 60 * 60 * 24);
        
            if (diffDays > 31) {
            showNotif("error", "Maksimal rentang tanggal adalah 31 hari");
            return false;
        }

        return true;
    };  
  const to_Start = (YYYYMMDD) => {
    if (!YYYYMMDD) return null;
    const startDate = `${YYYYMMDD} 00:00:00`;
    return startDate; // menghasilkan (YYYY-MM-DD HH:mm:ss)
    };
  const to_End = (YYYYMMDD) => {
    if (!YYYYMMDD) return null;
    const endDate = `${YYYYMMDD} 23:59:59`;
    return endDate; // menghasilkan (YYYY-MM-DD HH:mm:ss)
    };

  const [start, setStart] = useState(()=>awalBulan());
  const [end, setEnd] = useState(()=>to_End(today()));
  const jurnalKosong = {
    kode_cabang : kodeCabangUser,
    jenis : '',
    tanggal : '', //formatDATETIMEdariDATE(new Date()),
    nominal : 0,
    sumber : '',
    sal_sumber : 0,
    akun : '',
    subakun : '',
    saldo : 0,
    user : namaUser,
    created_at : ''
  };
  const [dataProses, setDataProses] = useState([jurnalKosong]);
  useEffect(() => {
    if (!isPusat) {
      setCabang(kodeCabangUser || '');
    }
    setDataProses((prev) => {
      const rows = Array.isArray(prev) ? prev : [];
      if (!rows.length) return prev;
      return rows.map((row) => ({
        ...row,
        kode_cabang: String(row?.kode_cabang || '').trim() || kodeCabangUser || '',
        user: String(row?.user || '').trim() || namaUser || '',
      }));
    });
  }, [isPusat, kodeCabangUser, namaUser]);
  const [opsiSumber, setOpsiSumber] = useState([]);
  const [opsiAkun, setOpsiAkun] = useState([]);
  const [opsiSubAkun, setOpsiSubAkun] = useState([]);
  const [filterSumber, setFilterSumber] = useState('total');
  const [filterAkun, setFilterAkun] = useState('total');
  const [filterSubakun, setFilterSubAkun] = useState('total');
  const { showNotif } = useNotification(); 
  const formatRibu = (value) => {
    if (value === null || value === undefined) return '0';
    return new Intl.NumberFormat('id-ID').format(Number(value));
  };
  const formattedPicker = (dateFull) => dateFull ? dateFull.split(" ")[0] : "";
   const handleOnChange = (e) => {
    e.preventDefault();
      const newStart = to_Start(start.split(' ')[0]);
      const newEnd = to_End(end.split(' ')[0]);
      
      if(validateRange(newStart,newEnd)){
        setStart(newStart);
        setEnd(newEnd);  
 
        console.log("New start =", newStart);
        console.log("New end =", newEnd);

        loadData(newStart, newEnd);
      }; 
  };

  const sortedData = useMemo(()=>{
    return sortData(dataProses, "created_at", "DSC");
  },[dataProses])

  const filteredData = useMemo(()=>{
      
      if (!Array.isArray(sortedData)) return [];
      const filterMatch = sortedData.filter(item => (filterSumber === "total" || trimTxt(item.sumber??'').includes(trimTxt(filterSumber??'')))
          && (filterAkun === "total" || trimTxt(item.akun??'').includes(trimTxt(filterAkun??'')))
          && (filterSubakun === "total" || trimTxt(item.subakun??'').includes(trimTxt(filterSubakun??''))));  
      return filterMatch;
    },[sortedData, filterSumber, filterAkun, filterSubakun]);  
  
  const cabangMap = useMemo(() => {
    const map = {};
      opsiCabang.forEach(c => {
      map[c.kode_cabang] = c.nama_cabang;
    });
    return map;
  }, [opsiCabang]);
  const totalMasuk = useMemo(() => {
      return filteredData
        .filter(x => x.jenis === 'drp' || x.jenis === 'kdr')
        .reduce((a,b)=> a + Number(b.nominal || 0), 0);
    }, [filteredData]);
  const totalKeluar = useMemo(() => {
      return filteredData
        .filter(x => x.jenis === 'kor' || x.jenis === 'nrm')
        .reduce((a,b)=> a + Number(b.nominal || 0), 0);
    }, [filteredData]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const filteredLength = Array.isArray(filteredData) ? filteredData.length : 0;
  const PAGE_SIZE_OPTIONS = [5, 10, 20, filteredLength || 30];
  const totalPages = Math.max(1, Math.ceil(filteredLength / pageSize));
  const paginatedData = useMemo(()=>{
    const startIndex = (page - 1) * pageSize;
    return filteredData.slice(startIndex, startIndex + pageSize);
    }, [filteredData, page, pageSize]);
  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [page, totalPages]);
  const maxVisible = 5;
  let startPage = Math.max(1, page - Math.floor(maxVisible / 2));
  let endPage = startPage + maxVisible - 1;
  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - maxVisible + 1);
    }
  const visiblePages = [];  
  for (let i = startPage; i <= endPage; i++) {
  visiblePages.push(i);}



  const loadOpsi = async (item) => {
    console.log("loadOpsi");
    try {
      const reqGroup = `${REQ_GROUP_PAGE18_OPSI_LOAD}-${String(item || '').trim()}`;
      api.cancelPendingRequests({
        group: reqGroup,
        reason: `refresh opsi petty ${item}`,
      });
      const res = await api.get(
        `${backendPort}/api/main/petty_opsi`,
        {
          params: {item},
          headers: {
            Authorization: `Bearer ${token}`,
          },
          requestGroup: reqGroup,
          timeout: 120000,
        }
      );

      switch(item){
        case "sumber" : return setOpsiSumber(res.data);
        case "akun" : return setOpsiAkun(res.data);
        case "subakun" : return setOpsiSubAkun(res.data);
      }
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
    }
  }

  //PAGINATION
  async function loadData(start,end) {
    setLoading(true);
    console.log("load start = ", start);
    console.log("load end = ", end);
    console.log("opsiCabang = ", opsiCabang);
    const t0 = performance.now();
    try {
      api.cancelPendingRequests({
        group: REQ_GROUP_PAGE18_JURNAL_LOAD,
        reason: 'refresh petty jurnal page18',
      });
      const res = await api.get(
        `${backendPort}/api/main/petty_jurnal`,
        {
          params: {
            start,
            end,
            cabang: cabang
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
          requestGroup: REQ_GROUP_PAGE18_JURNAL_LOAD,
          timeout: 30000,
        }
      );
      console.log("Waktu total request:", (performance.now() - t0).toFixed(2), "ms");
      if(res.data.length > 0){
        console.log("res.data = ", res.data);
        setDataProses(res.data);
      } else {
        console.log("res.data = kosong");
        setDataProses([jurnalKosong]);
      }
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    //loadData(start, end);
    loadOpsi('sumber');
    loadOpsi('akun');
    loadOpsi('subakun');
  }, []);

 
  
  
  return (
    <div className="container-fluid">
  
      <ShowPic
        open={openModal}
        onClose={() => setOpenModal(false)}
        row={selectedRow}
        backendPort={backendPort}
        token={token}
        onUploadSuccess={() => {
          setOpenModal(false);
          loadData(start, end);
        }}
      />
      <div className="row">
        <div className="fs-4 text fw-bold">
          <label>Jurnal Transaksi - {namaCabangUser}</label>
          <div className="flex-grow h-px bg-gray-300 mb-3"></div>
          <div className = 'row mb-3 justify-content-left'>
                <div className = 'col-md-2'>
                  <label className='fs-6 text fw-light'>Unit</label>
                  <select
                    className="form-control border-danger"
                    value={cabang}
                    onChange={(e) => {
                      setCabang(e.target.value);
                      }}>
                    <option value={''}>-Pilih Cabang-</option>    
                    {isPusat 
                        ? <option value={'all'}>-Semua Cabang-</option>
                        : null  }
                    {isPusat 
                        ? opsiCabang.map(x => ( <option value={x.kode_cabang}>{x.nama_cabang}</option>))
                        : <option value={kodeCabangUser}>{namaCabangUser}</option>
                    }
                  </select>
                </div>
                <div className = 'col-md-2'>
                  <label className='fs-6 text fw-light'>Tanggal Mulai</label>
                    <input
                        type="date"     
                        max={today()}
                        className="form-control border-danger"
                        value={formattedPicker(start)}
                        onChange={(e) => setStart(e.target.value)}
                    />
                </div>
                <div className='col-md-3'>
                    <label className='fs-6 text fw-light'>Tanggal Berakhir</label>

                    <div className='row g-1'>
                      <div className='col-9'>
                        <input
                          type="date"
                          max={today()}
                          className="form-control border-danger"
                          value={formattedPicker(end)}
                          onChange={(e) => setEnd(e.target.value)}
                        />
                      </div>

                      <div className='ml-2 pb-1 col-2'>
                        <button
                          type="button"
                          className="btn btn-primary w-100"
                          onClick={handleOnChange}
                        >
                          <i className="fa fa-solid fa-arrows-rotate text-white"/>
                        </button>
                      </div>
                    </div>
                  </div>
          </div>
          <div className="flex-grow h-px bg-gray-300 my-3"></div>
          </div> 
        {/* KOLOM 1 */}
        <div className='col-md-3'>
            {/*FILTER AKUN*/}            
            <div className="card-body p-0">
              <div className="row my-2 mx-0"> 
                  <div className='card card-body-0'>
                      <div className='fs-4 text mb-3 mt-2'>FILTER</div>
                      <label className='fs-8 text fw-light'>Sumber Dana</label>
                      <div className="mb-2">
                        <select
                        className="form-select"
                        value={filterSumber}
                        onChange={(e) => {setFilterSumber(e.target.value)}}
                        >
                            <option value={"total"}>-All-</option>
                            {opsiSumber.map((x,i) => <option key = {i} value = {x.sumber}>{x.sumber}</option>)}
                        </select>

                        </div>  
                      <label className='fs-8 text fw-light'>Akun</label>                    
                      <div className="mb-2">
                        <select
                        className="form-select"
                        value={filterAkun}
                        onChange={(e) => {setFilterAkun(e.target.value)}}
                            >
                              <option value={"total"}>-All-</option>
                            {opsiAkun.map((x,i) => <option key = {i} value = {x.akun}>{x.akun}</option>)}
                        </select>
                      </div>                 
                      <label className='fs-8 text fw-light'>Sub Akun</label>
                      <div className="mb-2">
                        <select className="form-select"
                        //style={{ width: 200 }}
                        value={filterSubakun}
                        onChange={(e) => {setFilterSubAkun(e.target.value)}}>
                            <option value={"total"}>-All-</option>
                            { 
                              opsiSubAkun.map((x,i) => 
                              x.akun === filterAkun ? <option key = {i} value = {x.subakun}>{x.subakun}</option> : null)
                            }
                        </select>
                      </div>
                      <label className='fs-8 text fw-light'>{`Kas Masuk`}</label>
                      <div className="justify-content-end text-end mb-3">
                        <input
                          className="form-control text-end"
                          value={formatRibu(totalMasuk)}
                          disabled
                        />
                      </div>
                      <label className='fs-8 text fw-light'>{`Kas Keluar`}</label>
                      <div className="justify-content-end text-end mb-3">
                        <input
                          className="form-control text-end"
                          value={formatRibu(totalKeluar)}
                          disabled
                        />
                      </div>
                    {/*DOWNLOAD SECTION*/}
                    <div className="row justify-content-between align-items-center g-3 py-2">
                        <hr/>
                        <div className="col-md-9">
                            <strong>DOWNLOAD JURNAL</strong>
                        </div>
                        <div className="col-md-3 d-grid">
                            <button
                            type="button"
                            className="btn btn-success"
                            onClick={() => {
                              if(dataProses[0].nominal) {
                                ExcelDown("tabel-Page18",`jurnal_petikas_${start.split(' ')[0]}_${end.split(' ')[0]}`);
                                showNotif('success','Download Berhasil');
                              } else {
                                showNotif('error','Data Kosong');
                              }}}
                            >
                            EXCEL
                            </button>
                        </div>
                        </div>
                    </div>
              </div>  
            </div>                        
        </div>
        {/* KOLOM 2 */}
        <div className="col-md-9">
            <div className='row justify-content-end text-end'>
            <div className="col-md-3 text-end">
                  <label className="form-label">Show</label>
                  <select
                    className="form-select w-auto d-inline-block ms-2"
                    value={pageSize}
                    onChange={e => {
                      setPageSize(Number(e.target.value));
                      setPage(1);
                    }}
                  >
                    {PAGE_SIZE_OPTIONS.map(x => (
                      <option key={x}>{x}</option>
                    ))}
                  </select>
            </div>
            </div>
            <table className="table table-bordered table-hover rounded-4" id='tabel-Page18'>
                <thead  >
                  <tr>
                    <th className='warna-table-header'>
                      <div className="d-flex justify-content-between align-items-center" >
                        <span>Id Trx</span>
                      </div>
                    </th>
                    <th className='warna-table-header'>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Cabang</span>
                      </div>
                    </th>
                    <th className='warna-table-header'>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Tanggal Input</span>
                      </div>
                    </th>
                    <th className='warna-table-header'>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Sumber Dana</span>
                      </div>
                    </th>
                    <th className='warna-table-header'>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Akun</span>
                      </div>
                    </th>
                    <th className='warna-table-header'>
                      <div className="text-center">
                        <span>SubAkun</span>
                      </div>
                    </th>
                     <th className='warna-table-header'>
                      <div className="text-center">
                        <span>Nominal</span>
                      </div>
                    </th>
                    <th className='warna-table-header'>
                      <div className="text-center">
                        <span>Keterangan</span>
                      </div>
                    </th>
                    <th className='warna-table-header'>
                      <div className="text-center">
                        <span>Tanggal Transaksi</span>
                      </div>
                    </th>
                    <th className = "warna-table-header text-center">Nota</th>
                  </tr>
                </thead>
                <tbody>
                    {paginatedData.map((row, i) => (
                      <tr key={`${i}-${row.id}`}>
                        <td className = 'text-end'>{row.id ? row.id : 'No Data'}</td>
                        <td className = 'text-start'>{cabangMap[row.kode_cabang] || ''}</td>
                        <td className = 'text-center'>{formatWIB(row.created_at) ? formatWIB(row.created_at) : ''}</td>
                        <td>{row.sumber ? row.sumber : ''}</td>
                        <td>{row.akun ? row.akun : '' }</td>
                        <td>{row.subakun ? row.subakun : ''}</td>
                        <td className = 'text-end' style={{color: row.jenis === "kor" ? "#DE370D" : "#00000"}}>{formatRibu(row.nominal) === -0 ? '0' : formatRibu(row.nominal)}</td>
                        <td style={{color: row.jenis === "kor" ? "#DE370D" : "#00000"}}>{row.catatan ?? ''}</td>
                        <td className = 'text-center'>{formatWIB(row.tanggal) ?? ''}</td>
                        <td>
                           <button
                              className="btn btn-sm btn-outline-primary"
                              onClick={() => {
                                setSelectedRow(row);
                                setOpenModal(true);
                              }}
                            >  {row.bukti ? <i className="fa fa-check-circle" style={{color: "#1491F7"}}/> : <i className="fa fa-circle-xmark" style={{color: "#F71414"}}/> }
                            </button>
                          </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              <div className="d-flex justify-content-between align-items-center my-2 mx-3">
            
            <div>
              {filteredLength > 0
                ? `Showing ${(page - 1) * pageSize + 1} to ${Math.min(page * pageSize, filteredLength)} of ${filteredLength} entries`
                : 'Showing 0 to 0 of 0 entries'}
            </div>
            

            <nav>
              <ul className="pagination mb-0">
                <li className={`page-item ${page === 1 && "disabled"}`}>
                  <button
                    className="page-link"
                    onClick={() => setPage(1)}
                  >
                    ←
                  </button>
                </li>

                {visiblePages.map(p => (
                  <li
                    key={p}
                    className={`page-item ${page === p && "active"}`}
                  >
                    <button className="page-link" onClick={() => setPage(p)}>
                      {p}
                    </button>
                  </li>
                ))}

                <li
                  className={`page-item ${
                    page === totalPages && "disabled"
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setPage(totalPages)}
                  >
                    →
                  </button>
                </li>
              </ul>
            </nav>
            
          </div>
         </div>
        </div>
      </div>
  );
}
